import { render, staticRenderFns } from "./order-table-none.vue?vue&type=template&id=3f86dda1"
import script from "./order-table-none.vue?vue&type=script&lang=js"
export * from "./order-table-none.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports